import { motion } from "framer-motion";
import { MapPin, Check } from "lucide-react";
import { INDUSTRIES, STATES } from "../data/site";
import { Reveal, Eyebrow } from "./Reveal";

export default function Coverage() {
  return (
    <section id="coverage" className="bg-mm-base py-24 sm:py-32" data-testid="coverage-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Industries */}
          <div>
            <Reveal><Eyebrow>Industries Served</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-4 font-heading font-black uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
                Engineered For The <span className="text-mm-green">Field</span>
              </h2>
            </Reveal>
            <div className="mt-10 space-y-px bg-mm-green/15 border border-mm-green/15">
              {INDUSTRIES.map((ind, i) => (
                <Reveal key={ind.name} delay={i * 0.1}>
                  <div className="group bg-mm-surface p-7 hover:bg-mm-panel transition-colors duration-300 flex gap-5">
                    <span className="font-mono text-mm-green text-sm pt-1">0{i + 1}</span>
                    <div>
                      <h3 className="font-heading font-bold uppercase text-2xl text-white group-hover:text-mm-green transition-colors">{ind.name}</h3>
                      <p className="mt-1 text-sm text-gray-400 leading-relaxed">{ind.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Coverage */}
          <Reveal delay={0.15}>
            <div className="beam p-8 sm:p-10">
              <div className="relative z-10">
                <div className="flex items-baseline gap-3 flex-wrap">
                  <MapPin className="text-mm-green self-center" />
                  <span className="font-heading font-black text-4xl sm:text-5xl text-white leading-none">All States</span>
                  <span className="font-mono text-xs uppercase tracking-[0.2em] text-gray-400 pb-1">Are Serviced</span>
                </div>
                <p className="mt-5 text-gray-400 leading-relaxed">
                  From our Odessa, TX headquarters, our mobile units reach fleets across the
                  Gulf Coast, Southwest, Southeast, and beyond, with the same standard everywhere.
                </p>
                <div className="mt-7 flex flex-wrap gap-2">
                  {STATES.map((st, i) => (
                    <motion.span
                      key={st}
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: i * 0.02 }}
                      className="inline-flex items-center gap-1.5 border border-mm-green/25 text-gray-300 text-xs font-mono uppercase tracking-wide px-3 py-1.5 hover:border-mm-green hover:text-mm-green transition-colors"
                    >
                      <Check size={12} className="text-mm-green" /> {st}
                    </motion.span>
                  ))}
                  <span className="inline-flex items-center border border-mm-green/25 text-mm-green text-xs font-mono uppercase px-3 py-1.5">+ more</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
